<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{docTypeData.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{docTypeData.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ docTypeData.description }}</dd>
              <dt class="col-sm-3">{{ $t('title.codingSchema') }} associato</dt>
              <dd class="col-sm-9" v-if="docTypeData.documentTypeCodingSchema">
                <dl class="row">
                  <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
                  <dd class="col-sm-9">
                    <b-badge :variant="`warning`">
                      <router-link v-if="docTypeData.documentTypeCodingSchema" class="cat"
                                   :to="{name: `documentTypeCodingSchemaShowRoute`, params:{id: docTypeData.documentTypeCodingSchema.id}}">
                        {{ docTypeData.documentTypeCodingSchema.code }}
                      </router-link>
                    </b-badge>
                  </dd>
                  <dt class="col-sm-3">{{ $t('page.generic.version') }}</dt>
                  <dd class="col-sm-9">{{docTypeData.documentTypeCodingSchema.codingSchemaVersion}}</dd>
                  <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
                  <dd class="col-sm-9">{{docTypeData.documentTypeCodingSchema.label}}</dd>
                  <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
                  <dd class="col-sm-9">{{docTypeData.documentTypeCodingSchema.description}}</dd>
                </dl>
              </dd>
            </dl>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import DocumentTypeService from '@/services/DocumentTypeService'

  const documentTypeService = DocumentTypeService.build();

  export default {
    name: 'DocTypeShow',
    props: {
      id: {
        required: true
      }
    },
    components: {
      PageTitle
    },
    data() {
      return {
        deleteModal: false,
        docTypeData: {}
      }
    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.docTypeData = await documentTypeService.read(this.id)
      }
    }
  }
</script>

